import { render, staticRenderFns } from "./marketType.vue?vue&type=template&id=c6fffe82"
import script from "./marketType.vue?vue&type=script&lang=js"
export * from "./marketType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports